import { normalizeSmileyCode, normalizeSmileySizePx } from '@/lib/xat-smilie-urls';
import { xatSmilieImageUrl } from '@/services/api-paths';

/** URL do proxy de smilies via backend Laravel (`/api/v1/xat/smilie/image`). */
export function smilieProxyUrl(code: string, size = 40): string {
  return xatSmilieImageUrl({
    name: normalizeSmileyCode(code),
    size: String(normalizeSmileySizePx(size)),
  });
}
